import { Save, SquarePen } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import apiServiceHandler from "../../service/apiService";

const SundayComp = ({ isDateOlderThanToday }) => {
  const [activeEdit, setActiveEdit] = useState(null);

  const [textFired, setTextFired] = useState("");
  const [textMessed, setTextMessed] = useState("");
  const [textCorrection, setTextCorrection] = useState("");

  const textFiredRef = useRef(null);
  const textMessedRef = useRef(null);
  const textCorrectionRef = useRef(null);

  const sendData = async () => {
    const payload = {
      fired_up: textFired,
      course_correction: textCorrection,
      messed_up: textMessed,
    };

    const res = await apiServiceHandler("POST", "api/weekTask", payload);
  };

  const handleEdit = (editType, ref, type) => {
    if (editType === type) {
      sendData();
      setActiveEdit(null); // Close the currently active textarea
    } else {
      setActiveEdit(type); // Open the clicked textarea
      setTimeout(() => {
        ref.current?.focus();
        ref.current.selectionStart = ref.current.value.length;
        ref.current.selectionEnd = ref.current.value.length;
      }, 0);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiServiceHandler("GET", "api/weekTask", {});
        if (res.status && Object.keys(res.data).length) {
          const data = res.data;
          if (data.fired_up && data.fired_up != "") {
            setTextFired(data.fired_up);
          }
          if (data.course_correction && data.course_correction != "") {
            setTextCorrection(data.course_correction);
          }
          if (data.messed_up && data.messed_up != "") {
            setTextMessed(data.messed_up);
          }
        }
      } catch (error) {
        console.error("Failed to fetch statements: " + error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <div className="daily-work-key" style={{marginTop: '1rem'}}>
        <div className="daily-work-body-items">
          <div className="daily-work-body-left-items" style={{ gap: "3rem" }}>
            {/* FIRED UP */}
            <div className="edit-area" style={{ marginTop: "0" }}>
              {(activeEdit === "fired" || textFired?.length > 0) && (
                <div className="edit-tag">FIRED UP</div>
              )}
              <div className="edit-win">
                <textarea
                  type="text"
                  className="sunday-input"
                  placeholder={activeEdit !== "fired" ? "FIRED UP" : ""}
                  ref={textFiredRef}
                  readOnly={activeEdit !== "fired"}
                  style={
                    activeEdit === "fired" 
                      ? {
                          background: "#f3f4f6",
                          padding: "2rem 1.2rem 0.5rem",
                        }
                      : textFired.length > 0
                      ? { padding: "2rem 1.2rem 0.5rem" }
                      : { paddingLeft: "35%" }
                  }
                  value={textFired}
                  onChange={(e) => setTextFired(e.target.value)}
                  onClick={() => {
                    if (!(activeEdit === "fired") && !isDateOlderThanToday) {
                      handleEdit(activeEdit, textFiredRef, "fired");
                    }
                  }}
                />

                {!isDateOlderThanToday && (
                  <div
                    className="square-pen"
                    onClick={() => {
                      handleEdit(activeEdit, textFiredRef, "fired");
                    }}
                  >
                    {activeEdit !== "fired" ? (
                      <SquarePen size={16} />
                    ) : (
                      <Save size={16} />
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* MESSED UP */}
            <div className="edit-area" style={{ marginTop: "0" }}>
              {(activeEdit === "messed" || textMessed?.length > 0) && (
                <div className="edit-tag">MESSED UP</div>
              )}
              <div className="edit-win">
                <textarea
                  type="text"
                  className="sunday-input"
                  placeholder={activeEdit !== "messed" ? "MESSED UP" : ""}
                  ref={textMessedRef}
                  readOnly={activeEdit !== "messed"}
                  style={
                    activeEdit === "messed" 
                      ? {
                          background: "#f3f4f6",
                          padding: "2rem 1.2rem 0.5rem",
                        }
                      : textMessed.length > 0
                      ? { padding: "2rem 1.2rem 0.5rem" }
                      : { paddingLeft: "33%" }
                  }
                  value={textMessed}
                  onChange={(e) => setTextMessed(e.target.value)}
                  onClick={() => {
                    if (!(activeEdit === "messed") && !isDateOlderThanToday) {
                      handleEdit(activeEdit, textMessedRef, "messed");
                    }
                  }}
                />

                {!isDateOlderThanToday && (
                  <div
                    className="square-pen"
                    onClick={() => {
                      handleEdit(activeEdit, textMessedRef, "messed");
                    }}
                  >
                    {activeEdit !== "messed" ? (
                      <SquarePen size={16} />
                    ) : (
                      <Save size={16} />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="daily-work-body-right-items">
            {/* COURSE CORRECTION */}
            <div className="edit-area" style={{ marginTop: "0" }}>
              {(activeEdit === "correction" || textCorrection?.length > 0) && (
                <div className="edit-tag">COURSE CORRECTION</div>
              )}
              <div className="edit-win">
                <textarea
                  type="text"
                  className="sunday-input"
                  placeholder={
                    activeEdit !== "correction" ? "COURSE CORRECTION" : ""
                  }
                  ref={textCorrectionRef}
                  readOnly={activeEdit !== "correction"}
                  style={
                    activeEdit === "correction" 
                      ? {
                          background: "#f3f4f6",
                          padding: "2rem 1.2rem 0.5rem",
                        }
                      : textCorrection.length > 0
                      ? { padding: "2rem 1.2rem 0.5rem" }
                      : { paddingLeft: "20%" }
                  }
                  value={textCorrection}
                  onChange={(e) => setTextCorrection(e.target.value)}
                  onClick={() => {
                    if (
                      !(activeEdit === "correction") &&
                      !isDateOlderThanToday
                    ) {
                      handleEdit(activeEdit, textCorrectionRef, "correction");
                    }
                  }}
                />

                {!isDateOlderThanToday && (
                  <div
                    className="square-pen"
                    onClick={() => {
                      handleEdit(activeEdit, textCorrectionRef, "correction");
                    }}
                  >
                    {activeEdit !== "correction" ? (
                      <SquarePen size={16} />
                    ) : (
                      <Save size={16} />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SundayComp;
